import React from 'react';
import { hasUserPermission } from '../utils/userPermissions';

const PermissionGate = ({ module, action, children }) => hasUserPermission(module, action) ? <>{children}</> : null;

export default PermissionGate;
